import script from "./EvidenceSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./EvidenceSection.vue?vue&type=script&setup=true&lang=ts"

import "./EvidenceSection.vue?vue&type=style&index=0&id=713ad6fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-713ad6fb"]])

export default __exports__